module.exports = __webpack_public_path__ + "static/media/fm.2b14fecb.svg";